import React from 'react'
export const ptBr = {
    values: {
        'The default units are defined in the Rig State Configurations. Click to go to default units configurations.':
            'As unidades podem ser alteradas nas configurações de Estado da Sonda. Se você alterá-las, todos os valores que as utilizam serão convertidos. Clique para ir para as configurações Estado da Sonda.',
        'Here you can switch the units between "meter-based (m)” or "foot-based (ft)" sets. This update will convert all the parameter values based on their units, and all the rigs’ physical models parameters will have their units changed and values converted.': `Você pode alterar as unidades entre os conjuntos "baseado em metros (m)” e "baseado em pés (ft)". Essa alteração converterá todos os valores baseados em suas unidades, e todos os parâmetros de modelos físicos de sondas terão suas unidades alteradas e valores convertidos.`,
        meter: 'metro',
        foot: 'pé',
        'foot-based': 'baseado em Pés',
        'meter-based': 'baseado em Metros',
        'Error loading algorithms configs': 'Erro ao carregar configurações de algorítmo.',
        'Settings saved successfully.': 'Configurações salvas com sucesso.',
        'Movement Threshold': 'Limite de Movimento',
        'Hook Load Ratio Threshold': 'Limite De Variação Do Peso No Gancho',
        error_saving_settings: 'Não foi possível salvar as configurações',
        'Enable SSA Filtering': 'Habilitar Filtro SSA',
        'Hook Load Without Block Weight': 'Peso No Gancho Sem Peso do Bloco',
        'GENERAL OPTIONS': 'OPÇÕES GERAIS',
        'Rig State auto detection': 'Auto detecção de modos de operação',
        Unavailability: 'Indisponibilidade',
        'Set status to': 'Mudar estado para',
        'of missing data': 'sem dados',
        'ALGORITHM OPTIONS': 'OPÇÕES DE ALGORITMOS',
        or: 'ou',
        'Here you can set the default parameters to be applied to all rigs that do not have a customized parameter preset.':
            'Aqui você pode configurar os parâmetros padrão a serem aplicados a todas as sondas que não tiverem parâmetros personalizados.',
        'Default value': 'Valor padrão',
        'specified value': 'valor específico',
        'This preset is already active! To deactivate it, you must activate another preset.':
            'O preset já está ativo! para desativá-lo, você deve ativar outro preset.',
        'This preset is active! To delete it, you must activate another preset.':
            'Este preset está ativo! Para apagá-lo, você precisa ativar outro preset.',
        cancel: 'cancelar',
        'New Preset': 'Novo Preset',
        'Block Weight': 'Peso do Bloco',
        'Hook Load Without Block Weight': 'Limite de Variação Do Peso No Gancho',
        'Minimum Operation Duration': 'Duração Mínima da Operação',
        'Block Weight Tolerance Threshold': 'Limite de Tolerância Para Peso Do Bloco',
        'Data Period': 'Período de dados',
        'Low Bit Depth Threshold': 'Mínima profundidade da broca',
        active: 'ativo',
        'Default rig state name': 'Nome de operação padrão',
        'Default color': 'Cor padrão',
        'New rig state name (optional)': 'Novo nome de operação (opcional)',
        'New color - RGB or HEXA (optional)': 'Nova cor - RGB ou HEXA (opcional)',
        'New color (optional)': 'Nova cor (opcional)',
        'The default values are defined in the Rig State Configurations. They are not applied to this Rig, unless you leave the fields blank. Click to go to default values configurations.':
            'Os valores padrão são definidos nas configurações de Rig State. Eles não estão aplicados a esta Rig, a não ser que o campo de valor especificado seja deixado em branco. Clique para ir para as configurações de valores padrão.',
        'The specified values are applied to the calculations of this rig. If you leave any field empty, the default value will be used.':
            'Os valores especificados estão aplicados aos cálculos desta Rig. Se algum campo for deixado em branco, o valor padrão será utilizado.',
        activate: 'ativar',
        'Delete preset': 'Remover preset',
        'Duplicate preset': 'Duplicar preset',
        unit: 'unidade',
        'Success!': 'Sucesso!',
        'Dismiss all': 'Dispensar',
        _dismiss_all_: () => {
            return (
                <>
                    Valores em <span>vermelho</span> foram atualizados nas configurações de Estado da Sonda. Para usar
                    um valor padrão atualizado, deixe o campo de valor especificado vazio.
                </>
            )
        },
        'Advanced Options': 'Opções Avançadas',
        _preset_rename_message_: ({ oldName, newName }) => {
            return `O preset "${oldName}” foi renomeado para "${newName}” com sucesso.`
        },
        _preset_create_message_: ({ name }) => {
            return `O preset "${name}" foi criado com sucesso.`
        },
        _preset_activate_message_: ({ name }) => {
            return `O preset "${name}" foi ativado com sucesso.`
        },
        _preset_delete_message_: ({ name }) => {
            return `O preset "${name}" foi apagado com sucesso.`
        },
        _preset_save_message_: ({ name }) => {
            return `As alterações dos parâmetros do preset "${name}" foram salvas com sucesso.`
        },
        _preset_ative_warn: ({ oldPreset, newPreset }) => {
            return `Se você ativar o preset "${newPreset}", o preset atual "${oldPreset}" será desativado.`
        },
        _change_config_unit_: ({ oldUnit, newUnit }) => {
            return (
                <p style={{ padding: 0 }}>
                    As unidades de parâmetros foram atualizadas de <b>"baseado em {oldUnit}"</b> para{' '}
                    <b>"baseado em {newUnit}"</b>. Todos os valores padrão e especificados que utilizavam as unidades
                    antigas foram convertidos.
                </p>
            )
        },
        'Paramater units have been updated!': 'Unidades de parâmetros foram atualizadas!',
        'Active Preset?': 'Ativar Preset?',
        Parameter: 'Parâmetro',
        'Input and output': 'Saídas',
        'Advanced parameters': 'Parâmetros avançados',
        'How to use': 'Como utilizar',
        'Info Query': 'A consulta a seguir funcionará com o gráfico de OpMode (dentro das opções do gráfico padrão)',
        Copy: 'Copiar',
        'Output Rig States': 'Estados da Sonda resultantes',
        here_overrite:
            'Aqui você pode escolher nomes dos Estados da Sonda diferentes dos padrões estabelecidos pelo algorítmo. (opcional)',
        rig_state_model_description: () => (
            <span>
                Versão mais recente do algoritmo Intelie Rig State Detection.
                <b> Acessível via funções pipes.</b>
            </span>
        ),
        rig_state_legacy_description: () => (
            <span>
                Versão mais antiga do algoritmo Intelie Rig State Detection.
                <div>
                    <b> Acessível apenas via funções pipes.</b>
                </div>
            </span>
        ),
        rig_state_simplified_description: () => (
            <span>
                Versão simplificada do algoritmo Intelie Rig State Detection.
                <div>
                    <b> Acessível apenas via funções pipes.</b>
                </div>
            </span>
        ),
        'Restore Defaults': 'Restaurar Padrões',
        'Data can not be empty': 'Os dados não podem ser vazios',
        'Rig State automatic detection': 'Detecção automática do Estado da Sonda',
        'GENERAL SETTINGS': 'CONFIGURAÇÕES GERAIS',
        'Try to infer the Macro Rig State': 'Inferência do Estado Global da sonda',
        'Successfully saved': 'Salvo com sucesso',
        'Error saving': 'Erro ao salvar',
        'Error loading process config': 'Erro ao carregar a configuração de processos',
        'Error loading channels identification': 'Erro ao carregar canais identificados',
        'Rig State History': 'Histórico de Estados da Sonda',
        'Current Rig State': 'Estado da Sonda atual',
        'Current Position': 'Posição atual',
        'Current Intervention': 'Intervenção atual',
        'In progress...': 'Em progresso...',
        'All time': 'Todo o período',
        'Edit Rig State Info': 'Editar Estado da Sonda',
        'Add Rig State Info': 'Salvar Estado da Sonda',
        'Rig State': 'Estado da Sonda',
        'Hole Section': 'Seção do poço',
        'Macro Rig State': 'Estado Global da Sonda',
        'Start time': 'Data inicial',
        'End time': 'Data final',
        'Initial depth': 'Profundidade inicial',
        'Final depth': 'Profundidade final',
        'There is no rig state history to be shown yet.\r\nYou can start it by adding a status.':
            'Não existe nenhum histórico de operações. Você pode iniciar adicionando um status.',
        'ADD RIG STATE': 'ADICIONAR',
        'SELECT MULTIPLE': 'SELECIONAR MÚLTIPLOS',
        'CANCEL SELECTION': 'CANCELAR SELEÇÃO',
        'Edit selected': 'Editar selecionado',
        'Delete selected': 'Deletar selecionado',
        From: 'Início',
        To: 'Fim',
        ' to ': 'Até',
        'Until ': 'De',
        'Show more': 'Exibir mais',
        'Error loading OpMode information': 'Erro ao carregar informações do OpMode',
        'RIG STATE': 'ESTADO DA SONDA',
        'MACRO RIG STATE': 'ESTADO GLOBAL DA SONDA',
        STARTED: 'INÍCIO',
        STOPPED: 'FIM',
        DURATION: 'DURAÇÃO',
        'Well name is a required field.': 'Nome do poço é obrigatório.',
        'Rig name is a required field.': 'Nome da sonda é obrigatório.',
        'Rig State name is a required field.': 'Nome do modo de operação é obrigatório.',
        'Start time is a required field': 'Data inicial é obrigatório.',
        'Required fields.': 'Verifique os campos obrigatórios',
        'Are you sure you want to delete the data': 'Tem certeza que deseja excluir o dado',
        channels_id_hint: ({ isAdmin }) => (
            <div>
                Esta funcionalidade depende da{' '}
                {isAdmin ? (
                    <a href="/#/config/standard-channels">Identificação de Canais</a>
                ) : (
                    <strong>Identificação de Canais</strong>
                )}{' '}
                para funcionar corretamente. Alguns de seus canais não estão identificados.
            </div>
        ),
        'Keep unchanged': 'Não modificar',
        'Hole Depth': 'Profundidade do poço',
        'Bit Depth': 'Profundidade da broca',
        Started: 'Início',
        'Estimated end': 'Fim estimado',
        'Time Elapsed': 'Tempo decorrido',
        Apply: 'Aplicar',
        SETTINGS: 'CONFIGURAÇÕES',
        when_enabled:
            'Quando ativado, gera-se um evento para cada modo de operação detectado exibindo nas interfaces da sonda e do poço.',
        'Intelie Rig State Detection Legacy': 'Intelie Rig State Legacy',
        'Rigstate detection': 'Detecção do estado da sonda',
        'Enable/disable rigstate automatic detection': 'Habilita/desabilita a detecção automática do estado da sonda',
        'If this toggle is disabled, the algorithm will use rigstate default values for calculations despite being filled in this tab':
            'Se esta opção estiver desabilitada, o algoritmo usará os valores padrão rigstate para cálculos, apesar de estar preenchido nesta guia',
        'The automatic detection of rig state is disabled. To enable it, go to ”models configurations” on the options menu next to the rig name.':
            'A detecção automática do estado da sonda está desativada. Para habilitá-la, vá para "configurações de modelos" no menu de opções próximo ao nome da sonda.',
        'The automatic detection of rig state is unavailable because there is no rig operating on this well.':
            'A detecção automática do estado da sonda está desativada pois não há sonda operando neste poço.',
        'Channels not identified': 'Canais não identificados',
        'The global configuration of rig state automatic detection is disabled.':
            'A configuração global de detecção automática do estado da sonda está desativada'
    }
}
